import $ from 'jquery';
import ModalContent from '../components/ModalContent';
import ModalView from '../components/ModalView';

export default class StaticCart {
  constructor({ el }) {
    this.$el = $(el);
    this.messages = JSON.parse($('[data-cart-messages]', this.$el).text());
    this.updateShippingLabel = this.updateShippingLabel.bind(this);
    this._bindEvents();
    this.timeouts = [];
    this.render();
  }

  _bindEvents() {
    this.events = [
      $('.cart-instructions textarea', this.$el).on('change.cart', event => saveSpecialInstructions(event)),
      $('.cart-item-upload', this.$el).on('click.cart', event => this.showFile(event)),
      $('.get-rates', this.$el).on('click.cart', () => this.calculateShipping()),
    ];

    this._bindCartItemEvents(this.$el);
  }

  _bindCartItemEvents(scope) {
    // these are added separately so they can be easily added after undoing an item removal
    this.events.push(
      $('.cart-item-quantity-display', scope).on('change.cart', event => this.updateQuantity(event)),
      $('.cart-item-decrease', scope).on('click.cart', event => this.updateQuantity(event)),
      $('.cart-item-increase', scope).on('click.cart', event => this.updateQuantity(event)),
      $('.remove span', scope).on('click.cart', event => this.removeProduct(event)),
    );
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.cart'));
  }

  render() {
    this.section = window.sectionJSON;
    this.cartText = window.cartTextJSON;

    this.$shippingStrings = $('[data-shipping-calculator-strings]');

    this.transitionend = (function (transition) {
      const transEndEventNames = {
        '-webkit-transition': 'webkitTransitionEnd',
        '-moz-transition': 'transitionend',
        '-o-transition': 'oTransitionEnd',
        transition: 'transitionend',
      };

      return transEndEventNames[transition];
    }(Modernizr.prefixed('transition')));

    this.savedProducts = [];

    if (this.$shippingStrings.length) {
      this.shippingCalculator();

      if (
        Shop.customerLoggedIn 
        && Shop.customerAddress 
        && Shop.customerAddress.country.length 
        && Shop.customerAddress.zip.length
      ) {
        this.calculateShipping(true);
      }

      Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
    }
  }

  saveSpecialInstructions() {
    const newNote = $('.cart-instructions textarea').val();
    Shopify.updateCartNote(newNote, (cart) => {
      // empty function so that Shopify"s callback isn"t invoked
    });
  }

  updatePrice($el, price) {
    $.each($el[0].attributes, (index, attribute) => {
      if (attribute.name.indexOf('data-currency') > -1) {
        $el.attr(attribute.name, '');
      }
    });

    $el
      .html(price)
      .attr(`data-currency-${Shop.currency}`, price)
      .attr('data-currency', Shop.currency);

    if (Shop.currencySwitcher) {
      $('[data-currency-converter]').trigger('updateCurrency', $el.parent());
    }
  }

  updateQuantity(e) {
    let newQuantity;
    const $productRow = $(e.target).parents('tr');
    const $productPrice = $productRow.find('.cart-item-total .money');
    const $productQuantity = $productRow.find('.cart-item-quantity-display');
    let oldQuantity = parseInt($productQuantity.val());
    oldQuantity = isNaN(oldQuantity) ? 1 : oldQuantity;

    if ($(e.target).hasClass('cart-item-quantity-display')) {
      newQuantity = oldQuantity;
    } else if ($(e.target).hasClass('cart-item-increase')) {
      newQuantity = oldQuantity + 1;
    } else if ($(e.target).hasClass('cart-item-decrease')) {
      newQuantity = Math.max(oldQuantity - 1, 0);
    }

    const variant = $productRow.data('variant');

    if (newQuantity === 0) {
      this.removeProduct(null, variant);
      return;
    }

    $productQuantity.val(newQuantity);

    Shopify.changeItem(variant, newQuantity, (cart) => {
      const cartItem = cart.items.filter(item => item.id === variant);
      const item = cartItem[0];
      const newProductPrice = Shopify.formatMoney(item.line_price, Shop.moneyFormat);
      const cartItemQuantity = item.quantity;
      this.updatePrice($productPrice, newProductPrice);
      $productQuantity.val(cartItemQuantity);

      if (cartItemQuantity !== newQuantity) {
        const modalMessage = Shop.cartQuantityError.message
          .replace('** quantity **', cartItemQuantity)
          .replace('** title **', item.title);

        const modalContent = new ModalContent({
          title: Shop.cartQuantityError.title,
          message: `<p>${modalMessage}</p>`,
          button: Shop.cartQuantityError.button,
        });

        new ModalView({
          model: modalContent,
          el: $('.modal-wrapper'),
        });
      }

      this.updateCart(cart);
    });
  }

  removeProduct(e, variant) {
    let itemRow;
    if (variant) {
      itemRow = $(`.variant-${variant}`);
    } else {
      variant = $(e.target).parents('tr').data('variant');
      itemRow = $(e.target).parents('tr');
    }

    const itemRowContents = itemRow.find('td');
    const productTitle = itemRow.data('title');
    const productURL = itemRow.data('url');

    this.savedProducts[variant] = {
      id: variant,
      content: itemRowContents,
      quantity: itemRow.find('td.quantity input').val(),
    };

    const showUndo = () => {
      const itemRemovedText = this.messages.itemRemovedText.replace('{{ item_title }}', `<a href='${productURL}'>${productTitle}</a>`);

      itemRow.html(`<td colspan='5'>${itemRemovedText} <span class='cart-undo' data-variant='${variant}'>${this.messages.cartUndo}</span>`);
      itemRow.removeClass('removing');

      this.events.push($('.cart-undo', itemRow).one('click.cart', event => this.undoRemoval(event)));
    };

    Shopify.removeItem(variant, (cart) => {
      if (Modernizr.csstransitions) {
        itemRow.addClass('removing').one(this.transitionend, () => showUndo());
      } else {
        showUndo();
      }

      this.updateCart(cart);
    });
  }

  undoRemoval(e) {
    const variant = $(e.target).data('variant');
    const savedProduct = this.savedProducts[variant];
    const undoneProduct = $(`tr.variant-${variant}`).html(savedProduct.content);

    Shopify.addItem(
      variant, 
      savedProduct.quantity, 
      () => Shopify.getCart(cart => this.updateCart(cart)),
    );

    this._bindCartItemEvents(undoneProduct);
  }

  updateCart(cart) {
    const newTotal = Shopify.formatMoney(cart.total_price, Shop.moneyFormat);
    this.updatePrice($('.cart-checkout .cart-price .money'), newTotal);

    const cartCount = cart.item_count;
    const cartCountText = cart.item_count === 1 ? this.cartText[0] : this.cartText[1];
    $('.bag-count').text(cartCount);
    $('.bag-text').text(cartCountText);
  }

  showFile(e) {
    const file = $(e.target).data('file');

    if (file.match(/(jpg|jpeg|png|gif)/)) {
      const image = `<img alt='' src='${file}'>`;

      const modalContent = new ModalContent({
        title: $(e.target).prev().text(),
        message: image,
      });

      new ModalView({
        model: modalContent,
        el: $('.modal-wrapper'),
      });
    }
  }

  shippingCalculator() {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.messages.shippingCalculatorSubmitButton,
      submitButtonDisabled: this.messages.shippingCalculatorDisabled,
      customerIsLoggedIn: Shop.customerLoggedIn,
      moneyFormat: Shop.moneyFormat,
    });

    const selectableOptions = $('.cart-shipping-calculator select');

    this.timeouts.push(
      setTimeout(() => selectableOptions.map((index, select) => this.updateShippingLabel(select)), 500),
    );

    $('.cart-shipping-calculator select').change(e => selectableOptions.map((index, select) => this.updateShippingLabel(select)));
  }

  onGetRates() {
    this.calculateShipping();
  }

  calculateShipping(auto) {
    let shippingAddress;
    $('.get-rates').val(this.messages.shippingCalculatorDisabled);

    if (auto) {
      shippingAddress = Shop.customerAddress;
    } else {
      shippingAddress = {};
      shippingAddress.zip = $('.address-zip').val() || '';
      shippingAddress.country = $('.address-country').val() || '';
      shippingAddress.province = $('.address-province').val() || '';
    }

    Shopify.getCartShippingRatesForDestination(shippingAddress, (rates) => {
      let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;
      if (!shippingAddress.province.length) {
        address = `${shippingAddress.zip}, ${shippingAddress.country}`;
      }
      if (!shippingAddress.zip.length) {
        address = `${shippingAddress.province}, ${shippingAddress.country}`;
      }
      if (!shippingAddress.province.length || !shippingAddress.zip.length) {
        address = shippingAddress.country;
      }

      const shippingCalculatorResponse = $('.cart-shipping-calculator-response');
      shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");

      const ratesFeedback = $('.shipping-calculator-response');

      if (rates.length > 1) {
        const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
        const feedback = this.messages.shippingCalculatorRates
          .replace('{{ address }}', address)
          .replace('{{ number_of_rates }}', rates.length)
          .replace('{{ rate }}', `<span class='money'>${firstRate}</span>`);
        ratesFeedback.html(feedback);
      } else if (rates.length === 1) {
        const response = this.messages.shippingCalculatorRate.replace('{{ address }}', address);
        ratesFeedback.html(response);
      } else {
        ratesFeedback.html(this.messages.shippingCalculatorNoRates);
      }

      rates.forEach((rate) => {
        const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
        const rateValues = this.messages.shippingCalculatorRateValues
          .replace('{{ rate_title }}', rate.name)
          .replace('{{ rate }}', `<span class='money'>${price}</span>`);
        $('.shipping-rates').append(`<li>${rateValues}</li>`);
      });

      $('.get-rates').val(this.messages.shippingCalculatorSubmitButton);
    });
  }

  handleErrors(errors) {
    let errorMessage = $.parseJSON(errors.responseText);
    errorMessage = this.messages.shippingCalculatorError.replace('{{ error_message }}', errorMessage.zip);
    $('.cart-shipping-calculator-response').html(`<p class='error'>${errorMessage}</p>`);
    $('.get-rates').val(this.messages.shippingCalculatorSubmitButton);
  }

  updateShippingLabel(select) {
    if (select) {
      select = $(select);
      let selectedOption = select.find('option:selected').val();

      if (!selectedOption || (selectedOption === '---')) {
        selectedOption = select.data('default');
        select.val(selectedOption);
      }

      select.prev('.selected-text').text(selectedOption);

      this.timeouts.push(setTimeout(() => {
        if (select.attr('name') === 'address[country]') {
          this.updateShippingLabel($('#address_province'));
        }
      },
      1500));
    }
  }

  onSectionUnload() {
    this._unbindEvents();
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }
}
